const personalController = "personal";
const documentController = "/document";
const usersController = "users";
const authController = "auth";
const dashboardController = "dashboard";
const driverController = "driver";
const vehicleController = "vehicle";
const bookingController = "booking";
const Lookup = "lookup";
const notificationsController = "notification"; 

export const API_CONFIG_URLS = {
  AUTH: {
    ME: `${personalController}/profile`,
    LOGIN: `${authController}/login`,
    LOGOUT: `${usersController}/logout`,
    RESEND_OTP: `${usersController}/forgot-password`,
    FORGOT_PASSWORD: `${usersController}/forgot-password`,
    RESET_PASSWORD: `${usersController}/reset-password`,
    VERIFY_FORGOT_OTP: `${usersController}/verify-password-otp`,
    CHANGE_PASSWORD: `${personalController}/change-password`,
  },
  DASHBOARD: {
    GET_DASHBOARD_STATS_CARDS: `${dashboardController}`,
    GET_DASHBOARD_REVENUE_GRAPH: `${dashboardController}/revenue-overview`,
    GET_DASHBOARD_BOOKING_STATUS_DISTRIBUTION: `${dashboardController}/booking-status-distribution`,
    
  },
  DRIVER: {
    GET_DRIVERS_LIST: `${driverController}`,
    GET_DRIVER_DETAILS: `${driverController}`,
    CREATE_DRIVER: `${driverController}`,
    UPDATE_DRIVER: `${driverController}`,
    DELETE_DRIVER: `${driverController}`,
    ASSIGN_VEHICLE: `${driverController}`,
    // Id routes are built in driver-service.ts: `${DRIVER}/{id}/<suffix>`.
    REVOKE_INVITE_SUFFIX: "revoke-invite",
    RESTORE_INVITE_SUFFIX: "restore-invite",
    MARK_INACTIVE_SUFFIX: "mark-inactive",
    PHONE_CHANGE_REQUEST_SUFFIX: "phone-change-request",
    APPROVE_PHONE_CHANGE_SUFFIX: "phone-change-request/approve",
    REJECT_PHONE_CHANGE_SUFFIX: "phone-change-request/reject",
  },
  VEHICLE: {
    GET_VEHICLES_LIST: `${vehicleController}`,
    GET_VEHICLE_DETAILS: `${vehicleController}`,
    CREATE_VEHICLE: `${vehicleController}`,
    UPDATE_VEHICLE: `${vehicleController}`,
    DELETE_VEHICLE: `${vehicleController}`,
    UPDATE_VEHICLE_STATUS: `${vehicleController}`,
  },
  BOOKING: {
    GET_BOOKINGS_LIST: `${bookingController}`,
    GET_BOOKING_DETAILS: `${bookingController}`,
    CANCEL_BOOKING: `${bookingController}`,
  },
  PRICING: {
    GET_PRICING_RULES: `${bookingController}/pricing/rules`,
    PLATFORM_SETTINGS: `${bookingController}/pricing/settings`,
  },
  USERS: {
    GET_USERS_LIST: `${usersController}/list`,
    GET_CUSTOMER_LIST: `${usersController}/customers`,
    GET_CUSTOMER_DETAILS: `${usersController}/customers`,
    UPDATE_CUSTOMER_STATUS: `${usersController}`,
  },
 
  PROFILE: {
    CHANGE_PASSWORD: `${personalController}/change-password`,
    EDIT_PROFILE: `${personalController}/profile`,
  },
  DOCUMENTS: {
    UPLOAD_DOCUMENTS: `${documentController}`,
    DOWNLOAD_IMAGE: `${documentController}/fetch`,
  },
  LOOKUP: {
    GET_ALL_USERS: `/${Lookup}/admin/users`,
  },
  NOTIFICATIONS: {
    GET_NOTIFICATION_LISTINGS: `/${notificationsController}`,
    MARK_ALL_AS_READ: `/${notificationsController}/mark`,
    NOTIFICATION_COUNT: `/${notificationsController}/count`
  },
};

export const multiFormDataHeader = {
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "text/plain",
  },
};

export const jsonFormatDataHeader = "application/json";
